import { LegacyAnchor } from '@/constants/anchors';
import PageAnchor from '@components/PageAnchor';
import ReportSection from '@components/ReportSection';
import ReportSectionHeader from '@components/ReportSectionHeader';
import { SharePrice } from './components/SharePrice';
import { MarketPerformance } from './components/MarketPerformance';
import { RelatedNews } from './components/RelatedNews';

interface Props {
  sectionNumber: number;
  companyName?: string;
  companyId?: string;
  uniqueSymbol?: string;
}
export function SharePriceNews(props: Props) {
  return (
    <ReportSection sectionNumber={props.sectionNumber}>
      <ReportSectionHeader
        title="Share Price &amp; News"
        sectionDescription={`How has ${props.companyName}'s share price performed over time and what events caused price changes?`}
      />
      <PageAnchor
        type="sub-section-title"
        id={LegacyAnchor.HEADER_PRICE_EVENTS}
      />
      <SharePrice id={props.companyId} uniqueSymbol={props.uniqueSymbol} />
      <hr />
      <MarketPerformance id={props.companyId} />
      <hr />
      <RelatedNews id={props.companyId} uniqueSymbol={props.uniqueSymbol} />
    </ReportSection>
  );
}
